import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import Header from './modules/_header.js';
import Flyout from './modules/_flyout.js';
import Video from './base/_video.js'

import './base/_object-fit-cover.js';


class Scripts {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();
	}

	ready() {
		focusWithin( 'label, form, fieldset' );

		this.header = new Header();
		this.flyout = new Flyout();
		this.video  = new Video();

		if (this.header.hamburger) {
	        this.header.hamburger.addEventListener('click', () => this.flyout.open('menu'));
	    }

	    // Check if this.header.search is not null or undefined and if it has any elements before adding event listeners
	    if (this.header.search && this.header.search.length > 0) {
	        this.header.search.forEach((search) => {
	            if (search) {
	                search.addEventListener('click', () => this.flyout.open('search'));
	            }
	        });
	    } 

	}

	resize() {
		if ( ! document.body ) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}
}

export default new Scripts;
